import { ChangeDetectionStrategy, Component, input, computed } from '@angular/core';
import { NgChartsModule } from 'ng2-charts';
import { ChartConfiguration, ChartType } from 'chart.js';
import { IntegrationStatusHealtOverTime } from 'src/app/admin/models/integration-status-health.model';

@Component({
    selector: 'nova-health-over-time',
    standalone: true,
    imports: [NgChartsModule],
    templateUrl: './health-over-time.component.html',
    styleUrls: ['./health-over-time.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HealthOverTimeComponent {
    values = input.required<IntegrationStatusHealtOverTime>();

    lineChartType: ChartType = 'line';

    private readonly baseChartOptions: ChartConfiguration['options'] = {
        elements: {
            line: {
                tension: 0.1
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Day',
                    align: 'center',
                    font: {
                        size: 14,
                        weight: 'bolder'
                    }
                },
                grid: {
                    display: false
                }
            },
            y: {
                position: 'left',
                grid: {
                    display: false
                },
                title: {
                    display: true,
                    text: 'Integrations Ran',
                    align: 'center',
                    font: {
                        size: 14,
                        weight: 'bolder'
                    }
                }
            },
            y1: {
                display: false
            }
        },
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 10,
                    boxHeight: 10
                }
            }
        }
    };

    lineChartData = computed(() => {
        const values = this.values();
        if (!values) {
            return { datasets: [], labels: [] };
        }

        const dataset = values.details.map((status) => ({
            data: status.counts ?? [],
            label: status.status.toString(),
            backgroundColor: status.color,
            borderColor: status.color,
            pointBackgroundColor: status.color,
            fill: 'false'
        }));

        return {
            datasets: dataset,
            labels: values.labels
        };
    });

    lineChartOptions = computed(() => {
        const values = this.values();

        // Only override if xAxisLabel is provided
        if (!values?.xAxisLabel) {
            return this.baseChartOptions;
        }

        return {
            ...this.baseChartOptions,
            scales: {
                ...this.baseChartOptions.scales,
                x: {
                    ...this.baseChartOptions.scales?.['x'],
                    title: {
                        ...this.baseChartOptions.scales?.['x']?.['title'],
                        text: values.xAxisLabel
                    }
                }
            }
        } as ChartConfiguration['options'];
    });

    totalIntegrations = computed(() => this.values()?.total ?? 0);
}
